import { UserProfileEntryProps } from '@ixicare/resources';
import { formatDate } from '@ixicare/ui';
import { BaseTableConfig, CsvAccessor, WithColumnManager, WithExport, WithTransformer } from '../DeviceTables/types';
import {
  HCP_DEFAULT_COLUMN_IDS,
  PROFILE_COLUMNS,
  PROFILE_COLUMN_IDS,
  ProfileTransformContext,
  RESIDENT_DEFAULT_COLUMN_IDS,
  transformProfileToRow,
} from './rowTransformers';
import { profileSortAccessors } from './sortAccessors';

export type ProfileTableConfig = BaseTableConfig &
  WithTransformer<UserProfileEntryProps, ProfileTransformContext> &
  WithColumnManager<UserProfileEntryProps> &
  WithExport<UserProfileEntryProps>;

const createdCsv: CsvAccessor<UserProfileEntryProps> = (p) => (p.created ? formatDate(p.created) : null);
const deviceUpdatedCsv: CsvAccessor<UserProfileEntryProps> = (p) =>
  p.ownedDevice?.status?.updatedOn ? formatDate(p.ownedDevice.status.updatedOn) : null;
const deviceTypeCsv: CsvAccessor<UserProfileEntryProps> = (p) => p.ownedDevice?.deviceType ?? null;

const baseCsvAccessors: Record<string, CsvAccessor<UserProfileEntryProps>> = {
  created: createdCsv,
  device: deviceTypeCsv,
  device_updated_at: deviceUpdatedCsv,
};

export const residentTableConfig: ProfileTableConfig = {
  tableId: 'residents',
  columns: PROFILE_COLUMNS,
  columnIds: PROFILE_COLUMN_IDS,
  defaultColumnIds: RESIDENT_DEFAULT_COLUMN_IDS,
  transformRow: transformProfileToRow,
  sortAccessors: profileSortAccessors,
  csvAccessors: baseCsvAccessors,
  defaultOrderBy: 'created',
  defaultAscOrder: false,
};

export const healthcareProviderTableConfig: ProfileTableConfig = {
  tableId: 'healthcareProviders',
  columns: PROFILE_COLUMNS,
  columnIds: PROFILE_COLUMN_IDS,
  defaultColumnIds: HCP_DEFAULT_COLUMN_IDS,
  transformRow: transformProfileToRow,
  sortAccessors: profileSortAccessors,
  csvAccessors: baseCsvAccessors,
  defaultOrderBy: 'created',
  defaultAscOrder: false,
};
